module.exports = __webpack_public_path__ + "static/media/npo-connect.7d4df1a9.png";